export const VITE_API_URL = import.meta.env.VITE_API_URL;
export const VITE_API_CLIENT_ID = import.meta.env.VITE_API_CLIENT_ID;
export const VITE_API_CLIENT_SECRET = import.meta.env.VITE_API_CLIENT_SECRET;
export const VITE_ENV = import.meta.env.VITE_ENV;
export const VITE_VERSION = import.meta.env.VITE_VERSION;
export const API_VERSION = "api/v1";
export const VITE_PUBLIC_GOOGLE_LOGIN_CLIENT_ID = import.meta.env
  .VITE_PUBLIC_GOOGLE_LOGIN_CLIENT_ID;
